import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalConfigService } from './global-config.service';

export interface PatientLocation {
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  patientCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class PatientLocationService {
  private apiUrl: string;

  constructor(private http: HttpClient, private globalConfig: GlobalConfigService) { 
    this.apiUrl = this.globalConfig.getApiUrl();
  }

  /**
   * Busca os dados reais de localização dos pacientes do backend
   * Retorna um array de objetos com a estrutura PatientLocation
   */
  getLocations(): Observable<PatientLocation[]> {
    // Tentativa de obter dados reais
    return this.http.get<any>(`${this.apiUrl}/patients/locations`)
      .pipe(
        map(response => {
          // Verificar se a resposta é válida
          if (!response || !Array.isArray(response)) {
            throw new Error('Formato de resposta inválido');
          }
          
          // Converter snake_case para camelCase
          return response.map(location => ({
            city: location.city,
            state: location.state,
            country: location.country,
            latitude: location.latitude,
            longitude: location.longitude,
            patientCount: location.patient_count // Mapear patient_count para patientCount
          }));
        }),
        catchError((error: HttpErrorResponse) => {
          let errorMsg = 'Erro ao buscar localizações de pacientes';
          
          if (error.error instanceof ErrorEvent) {
            // Erro do lado do cliente
            errorMsg = `Erro de conexão: ${error.error.message}`;
          } else {
            // Erro do lado do servidor
            switch (error.status) {
              case 401:
                errorMsg = 'Não autorizado. Faça login novamente.';
                break;
              case 403:
                errorMsg = 'Acesso proibido a este recurso.';
                break;
              case 404:
                errorMsg = 'Endpoint não encontrado no servidor.';
                break;
              case 500:
                errorMsg = 'Erro interno do servidor.';
                break;
              default:
                errorMsg = `Erro ${error.status}: ${error.statusText}`;
            }
          }
          
          console.error(errorMsg, error);
          throw error; // Propaga o erro para ser tratado pelo componente
        })
      );
  }
} 